







import { defineComponent, PropType, computed } from '@vue/composition-api';
import { IntentType, Message } from '../../dataType';
import { useLocale } from '../../hooks/useLocale';

export default defineComponent({
  props: {
    data: {
      type: String as PropType<IntentType>,
      required: true
    },
    message: {
      type: Object as PropType<Message<any>>,
      required: true
    }
  },
  setup(props) {
    const { t } = useLocale();
    const intentMap = {
      work_report: t('saas.robotChat.intent.report'),
      sql_query: t('saas.robotChat.dataQuery'),
      risk: t('saas.robotChat.risk')
    };
    const intent = (props.data in intentMap) ? intentMap[props.data as keyof typeof intentMap] : '';
    const msg = computed<string>(() => t('saas.robotChat.changeIntentTips', { intent }));
    return {
      t,
      msg
    };
  }
});
